import React, {Component} from 'react';
import swal from 'sweetalert';

class DeleteEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            imgurl: ''
        };
        this.id = this.props.dataid;
        this.deleteEvent = this.deleteEvent.bind(this);
    }

    deleteEvent(e) {
        e.preventDefault();
        swal({
          title: "Suppression d'évènement",
          text: "Voulez-vous supprimer l'évènement ?",
          icon: "warning",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
            fetch('https://api.goaltiming.be/events/' + this.id, {
                method: 'DELETE',
                headers: new Headers({
                    'Authorization': this.props.token
                }), 
            })
            .then(res => res.json())
            .then(
                (result) => {
                    window.location.replace('/delete');
                },(error) => {
                    console.log(error);
                }
            )
          }
        });
    }

    render() {
        const { error } = this.state;

        if (error) {
        return <div>Erreur : {error.message}</div>;
        } else {
            return (
                <div>
                    <button onClick={this.deleteEvent} className="btnDelete">Supprimer l'évènement</button>
                </div>
            );
        }
    }
}

export default DeleteEvent